<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-layout>
      <h1><span>{{title}}</span></h1>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark class="mx-1" :to="{name: 'AdminQuestions'+suffix+'Add'}">Добавить</v-btn>
      <v-btn color="primary" dark class="ml-1 mr-0" :to="{name: 'AdminIndex'}">Вернуться</v-btn>
    </v-layout>
    <search :search="search"/>
    <data-table :items="items" :headers="headers">
      <tr slot-scope="props">
        <td class="text-xs-center">{{ props.item.number }}</td>
        <td class="text-xs-center">{{ props.item.category }}</td>
        <td>{{ props.item.text }}</td>
        <td class="justify-center layout px-0">
          <v-btn flat icon :to="{name: 'AdminQuestions'+suffix+'Edit', params: {id: props.item.id.toString()}}">
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn flat icon @click="deleteItem(props.item)">
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </tr>
    </data-table>
    <pagination :pagination="pagination" @currentPageChanged="initRoute"/>
    <Dialog :dialog="dialogs.delete" title="Вы действительно хотите удалить?" :maxWidth="500">
      <p>Текст: {{ deletedItem.text }}</p>
      <p>Номер: {{ deletedItem.number }}</p>
      <p>Категория: {{ deletedItem.category }}</p>
      <div>
        <h5>Варианты</h5>
        <p v-for="(item, i) in deletedItem.answers" :key="i"
           :class="deletedItem.rightAnswer && deletedItem.rightAnswer.id === item.id ? 'success--text' : ''">
          {{ item.text }} </p>
      </div>
      <template slot="actions">
        <v-btn color="accent" flat @click.native="closeDelete">Нет</v-btn>
        <v-btn color="accent" flat @click.native="deleteConfirm">Да</v-btn>
      </template>
    </Dialog>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import Pagination from '@/components/fragments/Pagination'
import DataTable from '@/components/fragments/DataTable'
import Dialog from '@/components/fragments/Dialog'
import Search from '@/components/fragments/Search'

export default {
  components: {Search, DataTable, Pagination, Dialog},
  props: {
    title: String,
    items: Array,
    search: Object,
    pagination: Object,
    dialogs: Object,
    suffix: String,
    replaceRoute: Boolean
  },
  data: () => ({
    headers: [
      {text: '№', align: 'center', sortable: false, value: 'number'},
      {text: 'Категория', align: 'center', sortable: false, value: 'category'},
      {text: 'Текст', align: 'left', sortable: false, value: 'text'},
      {text: 'Действия', value: 'id', sortable: false}
    ]
  }),
  computed: {
    deletedItem () {
      return this.items[this.dialogs.delete.itemIndex] ? this.items[this.dialogs.delete.itemIndex] : Object.assign({}, JSON.parse(JSON.stringify(this.dialogs.defaultItem)))
    },
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    }
  },
  methods: {
    save () {
      this.$emit('save')
    },
    deleteItem (item) {
      this.dialogs.delete.itemIndex = this.items.indexOf(item)
      this.dialogs.delete.status = true
    },
    deleteConfirm () {
      this.$emit('deleteConfirm')
    },
    closeDelete () {
      this.dialogs.delete.status = false
      this.dialogs.delete.itemIndex = -1
    },
    initRoute () {
      let query = {}
      query.page = this.pagination.currentPage
      if (this.search.number) query.number = this.search.number
      if (this.search.category.length > 0) query.category = this.search.category.toString()
      if (this.replaceRoute) {
        this.$router.replace({query: query})
      } else {
        this.$router.push({query: query})
      }
    }
  },
  watch: {
    'dialogs.delete.status' (val) {
      val || this.closeDelete()
    },
    search: {
      handler () {
        sessionStorage.setItem('hiddenLoading', true)
        this.initRoute()
      },
      deep: true
    },
    '$route.query': {
      handler () {
        this.$emit('loadQuestions')
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/questions/QuestionList.vue